import {ContentContext} from "../../../../../utils/contexts";

import {  ButtonGroup, Button  } from "@mui/material";
import {  KeyboardArrowLeft, KeyboardArrowRight  } from "@mui/icons-material";

class PaginationActions extends React.PureComponent {
  handlePage = newPage => {
    const { setProperty, fetchContent, searchMode, searchQuery, pageSize } = this.context;

    setProperty("page", newPage);

    fetchContent(searchQuery, undefined, newPage);
  };

  render() {
    const { page, total, pageSize, loadingContent } = this.context;

    return (
      <ButtonGroup sx={{marginLeft: '0.5rem'}}>
        <Button
          sx={{padding: '0.5rem'}}
          disabled={page === 1 || loadingContent}
          onClick={() => this.handlePage(page - 1)}
          id="paginationBackBtn"
        >
          <KeyboardArrowLeft fontSize="small" />
        </Button>
        <Button
					sx={{padding: '0.5rem'}}
          disabled={page === Math.ceil(total / pageSize) || loadingContent}
          onClick={() => this.handlePage(page + 1)}
          id="paginationForwardBtn"
        >
          <KeyboardArrowRight fontSize="small" />
        </Button>
      </ButtonGroup>
    );
  }
}

PaginationActions.contextType = ContentContext;

export default PaginationActions;
